<template>
  <div class="button-container">
    <p class="microcopy bold-red">＼最大91%OFF・即日対応可能！／</p>
    <a href="https://www.rentracks.jp/adx/r.html?idx=0.59243.389260.11327.16166&dna=181935" class="official-website-button" target="_blank" rel="nofollow noopener"
      aria-label="！無料見積もりはこちらから（新しいタブで開く）">
      無料見積もりを依頼する ▶︎
    </a>
    <p class="website-link">
      <a href="https://www.rentracks.jp/adx/r.html?idx=0.59243.389260.11327.16166&dna=181935" target="_blank" rel="nofollow noopener">
        https://kyutouki-kaketsuketai.com
      </a>
    </p>
  </div>
</template>

<style scoped>
.button-container {
  text-align: center;
  background: #f9fbff;
  padding: 18px 14px 22px;
  padding-top: 0;
}

.microcopy {
  font-size: 16px;
  margin: 0 0 10px;
  padding: 0;
}

.bold-red {
  color: #c62828;
}

.limited-down-label {
  display: flex;
  justify-content: center;
  position: relative;
  margin: 0 auto 8px;
}

.limited-down-label>span {
  display: inline-block;
  background: #e53935;
  color: #fff;
  font-weight: 900;
  font-size: 1.1rem;
  letter-spacing: .02em;
  padding: 8px 18px;
  position: relative;
}

.limited-down-label>span::after {
  content: "";
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: -10px;
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 10px solid #e53935;
}


.campaign-banner {
  display: block;
  margin: 14px auto 6px;
  max-width: 820px;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 4px 14px rgba(0, 0, 0, .08);
  transition: transform .08s ease, box-shadow .2s ease;
}

.campaign-banner:hover {
  transform: translateY(-1px);
  box-shadow: 0 10px 24px rgba(0, 0, 0, .12);
}

.campaign-banner img {
  display: block;
  width: 100%;
  height: auto;
}

.campaign-caution {
  margin: 4px 0 12px;
  font-size: .9rem;
  text-align: left;
  color: #666;
  line-height: 1.5;
  margin-bottom: 20px;
}

.official-website-button {
  --btn-bg: #ff7a00;
  --btn-bg-dark: #e96e00;
  --btn-grad-top: #ffa043;
  --btn-radius: 999px;

  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  max-width: 720px;
  box-sizing: border-box;
  padding: 22px 28px;
  font-size: 22px;
  font-weight: 800;
  line-height: 1.25;
  color: #fff;
  text-decoration: none;
  text-align: center;
  background: linear-gradient(180deg, var(--btn-grad-top) 0%, var(--btn-bg) 40%, var(--btn-bg) 100%);
  border: 2px solid var(--btn-bg-dark);
  border-radius: var(--btn-radius);
  position: relative;
  overflow: hidden;
  transition: transform .08s ease, box-shadow .2s ease, filter .2s ease;
}

.official-website-button::after {
  content: "▶";
  font-size: 1em;
  translate: 0 1px;
}

.official-website-button::before {
  content: "";
  position: absolute;
  top: 0;
  left: -80px;
  width: 60px;
  height: 100%;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, .55) 50%, rgba(255, 255, 255, 0) 100%);
  transform: skewX(-20deg);
  animation: shine 3.5s infinite;
  pointer-events: none;
}

@keyframes shine {
  0% {
    left: -80px;
  }

  60% {
    left: 115%;
  }

  100% {
    left: 115%;
  }
}

.official-website-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 14px 28px rgba(233, 110, 0, .32);
  filter: brightness(1.02);
}

.official-website-button:active {
  transform: translateY(0);
  box-shadow: 0 8px 16px rgba(233, 110, 0, .22);
}

.official-website-button:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px #fff, 0 0 0 6px rgba(255, 122, 0, .9);
}

.website-link {
  font-size: 14px;
  margin: 8px 0 0;
  font-weight: 700;
}

.website-link a {
  color: #3f51b5;
  text-decoration: underline;
  word-break: break-all;
}

.official-website-button {
  width: 80%;
}

@media (max-width:600px) {
  .official-website-button {
    width: 100%;
    font-size: 1.1rem;
    padding: 18px 20px;
  }

  .microcopy {
    font-size: .95rem;
    margin-bottom: 8px;
  }
}

@media (prefers-color-scheme:dark) {
  .official-website-button {
    filter: saturate(1.05) brightness(1.05);
  }
}
</style>
